import { getImageUrl } from "../../../../../helpers/PB";

const MiscellaneousConfig = {
  collection: "miscellaneous",
  single: true,
  fields: [
    "id",
    "return_to_label",
    "footer_header",
    "last_updated_label",
    "last_updated_source",
    "footer_disclaimer.id",
    "navigation_image.id",
    "navigation_header",
    "navigation_manage_link_text",
    "generated_reports_folder.id",
    "login_image.id",
    "privacy_policy_text",
    "contact_admin_text",
    "copyright_text",
    "request_password_success_message",
    "unsaved_progress_message"
  ],

  adapter: class Miscellaneous {
    constructor(misc) {
      Object.assign(this, misc);
      this.footer_disclaimer = misc.footer_disclaimer?.id;
      this.navigation_image = getImageUrl(misc.navigation_image?.id);
      this.generated_reports_folder = misc.generated_reports_folder?.id;
      this.login_image = getImageUrl(misc.login_image?.id);
    }
    map(collections, maps) {
      this.footer_disclaimer = maps.disclaimers[this.footer_disclaimer];
      this.primary_product = maps.products[this.primary_product];
    }
  }
};

export default MiscellaneousConfig;
